module.exports = __webpack_public_path__ + "img/4.f43ff1b0.png";